


































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig, UseModal } from "@/components/root/modal";
import VirtualTable from "@/components/table/VirtualTable.vue";
import TableRow from "./TableRow.vue";
import { table_config } from "./table.config";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  Ref,
  ref,
} from "@vue/composition-api";
import { EventBus } from "@/eventbus";

import { emptyFn } from "@/fp";
import * as menus from "./menus";
import { UseCollection } from "@/common/composition/use-collection";
import { AxisType, CoordinateInputTier1Tier2 } from "@/gql/types";
import { InfoTypesCountModalProps } from "./model";
import * as api from "./api";
import EventsModalVue from "../events-modal/EventsModal.vue";
import { cord } from "@/gql/lib";
import { EventsModalProps } from "../events-modal/model";
import { pxToRem } from "@/common/dom.functions";
import { SharedState } from "@/common/state";
export default Vue.extend({
  components: {
    Modal,
    VirtualTable,
  },
  props: ["modalData"],
  setup(props) {
    const modal_props = computed(
      () => props.modalData as InfoTypesCountModalProps
    );

    // =========== info types =============

    const modal_config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      backdropDismiss: true,
      width: "115rem",
      withTopRightCloseBtn: true,
      height: Math.min(65, pxToRem(innerHeight) * 0.9) + "rem",
    };

    const entities_collection = UseCollection<
      any,
      { cursor: string; coordinate: CoordinateInputTier1Tier2 }
    >(async ({ coordinate, cursor }) => {
      return await api.get_entities({
        coordinate,
        cursor,
      });
    });

    const load_more_entities = async () => {
      if (entities_collection.has_more.value) {
        await entities_collection.load_more_items();
      }
    };

    const selected_entity_id = ref("");

    const coordinate: Ref<CoordinateInputTier1Tier2> = ref({
      x: cord(AxisType.None, []),
      y: cord(AxisType.None, []),
      z: {
        type: "Month",
        values: [],
      },
    } as CoordinateInputTier1Tier2);

    const on_show_events = async (p: {
      item: any;
      mode: "events" | "files";
      rowEl: HTMLElement;
    }) => {
      SharedState.ifIsPayingUser(
        async () => {
          const label =
            SharedState.allInfoTypes.value[modal_props.value.info_type];
          const title = modal_props.value.events.title(p.item, label.labelName);
          const files_title = modal_props.value.files_title;

          const coordinates = modal_props.value.events.coordinate(
            p.item,
            label.id
          );
          console.log("coordinates : ", coordinates);
          await UseModal().show(EventsModalVue, {
            title,
            files_title,
            source: modal_props.value.source || "",
            show_back: true,
            coordinates: [coordinates],
          } as EventsModalProps);
        },
        { premium_modal_key: "what-popup-2024" }
      );
    };

    const on_show_table_row_menu = (p: { item: any; event: MouseEvent }) => {
      menus.employee_menu({
        ...p,
        info_types: [modal_props.value.info_type],
      });
    };

    const subs = {
      show_events: emptyFn(),
      show_files: emptyFn(),
      show_menu: emptyFn(),
      show_event_menu: emptyFn(),
    };

    const reload_data = async () => {
      entities_collection.clear();
      await entities_collection.load_items({
        cursor: "",
        coordinate: coordinate.value,
      });
    };

    onMounted(async () => {
      coordinate.value = modal_props.value.coordinate;
      subs.show_events = EventBus.listen("events", on_show_events);
      subs.show_menu = EventBus.listen("showMenu", on_show_table_row_menu);
      entities_collection.clear();
      await reload_data();
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      modal_config,
      table_config,
      TableRow,
      selected_entity_id,
      is_loading: entities_collection.is_loading,
      has_no_results: entities_collection.has_no_results,
      items: computed(() =>
        entities_collection.items.value.map((d) => {
          if (d.id == modal_props.value.info_type) {
            d.is_parent = true;
          }
          return d;
        })
      ),
      load_more_entities,
    };
  },
});
